import React from 'react';

import { Link } from '@rover/kibble/core';

import type { ToastLink } from './Toast.common';

export type ToastFooterLinkProps = {
  link: ToastLink;
  /** Runs after the caller's own handler: acting on a toast is also done with it. */
  onPressed: () => void;
};

export const TOAST_LINK_TEST_ID = 'toast-link';

/**
 * The toast's one action. Hybrid like Banner: it composes only cross-platform primitives, so this
 * file serves web and native both.
 */
const ToastFooterLink = ({ link, onPressed }: ToastFooterLinkProps): JSX.Element => (
  <Link
    testID={TOAST_LINK_TEST_ID}
    size="100"
    fontWeight="semibold"
    // Link navigates to `href` once `onPress` resolves, and an empty one is how it is told not to.
    href={link.href ?? ''}
    onPress={() => {
      link.onPress?.();
      onPressed();
    }}
  >
    {link.label}
  </Link>
);

export default ToastFooterLink;
